import { ShortcutTypeGlobal } from 'src/app/samwebDescription/samweb/shortcuts/shortcutTypeGlobal';

export class OpenHotkeyDuplicationDialog {
   public static readonly type = '[Hotkey Behaviour State] open hotkey duplication dialog';

   constructor(public shortcutType: ShortcutTypeGlobal) {}
}

export class CloseHotkeyDuplicationDialog {
   public static readonly type = '[Hotkey Behaviour State] close hotkey duplication dialog';

   constructor(public shortcutType: ShortcutTypeGlobal) {}
}
